import axios from "axios";

export const userLogin = async (baseUrl, mobilePhone, password) => {
  let userLoginRes = null;

  const body = {
    mobilePhone,
    password,
  };
  await axios
    .put(baseUrl + `/meeting/login`, body)
    .then((res) => {
      if (res.data.status === 200) {
        userLoginRes = {
          status: res.status,
          data: res.data.data,
        };
      } else {
        userLoginRes = {
          status: res.data.status,
          data: res.data.message,
        };
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        userLoginRes = {
          status: error.response.status,
        };
      }
    });
  return userLoginRes;
};

export const userLoginSMS = async (baseUrl, mobilePhone, password, code) => {
  let userLoginSMSRes = null;

  const body = {
    mobilePhone,
    password,
    code,
  };

  await axios
    .put(baseUrl + `/meeting/login/code`, body)
    .then((res) => {
      if (res.data.status === 200) {
        userLoginSMSRes = {
          status: res.data.status,
          data: res.data,
        };
      } else if (res.data.status === 401) {
        userLoginSMSRes = {
          status: res.data.status,
          data: res.data.message,
        };
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        userLoginSMSRes = {
          status: error.response.status,
        };
      }
    });

  return userLoginSMSRes;
};

export const userLogout = async (baseUrl, token) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  let userLogoutRes = null;

  await axios
    .get(baseUrl + `/meeting/logout`, config)
    .then((res) => {
      userLogoutRes = {
        status: res.status,
        data: res.data.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        userLogoutRes = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return userLogout;
};
